import Vue from "vue";
import Router from "vue-router";

import Layout from 'src/components/Layout.vue';

import Welcome from 'src/components/Views/Welcome.vue';
import Cascader from 'src/components/Views/Cascader.vue';
import Patients from 'src/components/Views/Patients.vue';
import Examinations from 'src/components/Views/Examinations.vue';
import Operations from 'src/components/Views/Operations.vue';
import Checkups from 'src/components/Views/Checkups.vue';
import Medications from 'src/components/Views/Medications.vue';
import Users from 'src/components/Views/Users.vue';
import AdSettings from 'src/components/Views/AdSettings.vue';
import Dashboards from 'src/components/Views/Dashboards.vue';

Vue.use(Router);


const routes = [{
        path: '/',
        redirect: 'welcome',
        component: Layout,
        children: [{
                path: 'welcome/:myhash?',
                name: 'welcome',
                component: Welcome
            },
            {
                path: 'patients',
                name: 'patients',
                component: Patients
            },
            {
                path: 'examinations',
                name: 'examimntions',
                component: Examinations
            },
            {
                path: 'operations',
                name: 'operations',
                component: Operations
            },
            {
                path: 'checkups',
                name: 'checkups',
                component: Checkups
            },
            {
                path: 'medications',
                name: 'medications',
                component: Medications
            },
            {
                path: 'cascader',
                name: 'Cascader',
                component: Cascader
            },

            {
                path: 'users',
                name: 'Users',
                component: Users
            },

            {
                path: 'adsettings',
                name: 'AdSettings',
                component: AdSettings
            },

            {
                path: 'dashboards',
                name: 'Dashboards',
                component: Dashboards
            },

        ]
    },

];

export default routes

